export default "__VITE_ASSET__28e4ff41__"